import { toast } from "sonner";
import { errorMessage } from "./api";

async function writeClipboard(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    const area = document.createElement("textarea");
    area.value = text;
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    const ok = document.execCommand("copy");
    document.body.removeChild(area);
    return ok;
  }
}

export async function copyEmails(request) {
  try {
    const { data } = await request();
    if (!data.count) {
      toast.error("Aucune adresse email dans cette sélection.");
      return;
    }
    if (!(await writeClipboard(data.text))) {
      toast.error("La copie a échoué. Réessayez.");
      return;
    }
    const s = data.count > 1 ? "s" : "";
    toast.success(`${data.count} adresse${s} email copiée${s}`, {
      description: data.without_email ? `${data.without_email} contact(s) sans email ignoré(s)` : undefined,
    });
  } catch (error) {
    toast.error(errorMessage(error));
  }
}

export async function downloadCsv(request, fallbackName = "annuaire-la-melee.csv") {
  try {
    const response = await request();
    const match = /filename="([^"]+)"/.exec(response.headers["content-disposition"] || "");
    const url = URL.createObjectURL(new Blob([response.data], { type: "text/csv;charset=utf-8" }));
    const link = document.createElement("a");
    link.href = url;
    link.download = match?.[1] || fallbackName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
    toast.success("Export CSV téléchargé");
  } catch (error) {
    toast.error(errorMessage(error, "L'export a échoué. Réessayez."));
  }
}
